import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TOPMATE_URL = 'https://topmate.io/acharya_ji_ajay_l_agrawal/2021139';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-brand-light">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-24">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-stone-500 text-base font-bold hover:text-brand-gold transition-colors mb-12"
        >
          <span className="text-xl">←</span> Return to main page
        </Link>
        
        <div className="mb-14 border-b border-stone-200 pb-10">
          <p className="text-brand-gold text-sm uppercase tracking-widest font-bold mb-4">Legal</p>
          <h1 className="text-5xl font-serif text-brand-dark mb-4">Terms of Service</h1>
          <p className="text-stone-500 text-base font-medium">
            Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}
          </p>
        </div>

        <div className="space-y-12 text-stone-700 font-medium text-lg leading-relaxed">
          
          <Section title="1. Nature of Services">
            <p>
              Acharyaji Ajay L Agarwal offers Vedic Astrology and Vastu Shastra advisory consultations. These services offer perspective on timing, cycles, and spatial energy regarding personal and professional decisions.
            </p>
            <p>
              These services are strictly advisory. They are not a substitute for professional financial, legal, medical, or psychological advice. All decisions remain the sole responsibility of the client.
            </p>
          </Section>

          <Section title="2. Scope of Consultation">
            <p>
              A consultation consists of a video session preceded by chart preparation. Sessions are booked and managed via Topmate. Outcomes or specific predictions cannot be guaranteed, as astrology is an interpretive science.
            </p>
          </Section>

          <Section title="3. Booking and Payment">
            <p>
              All bookings and payments are processed through Topmate. By booking, you agree to Topmate's terms. The consultation fee is $42 USD per session, payable at booking.
            </p>
          </Section>

          <Section title="4. Cancellation and Rescheduling">
            <p>
              Cancellations made more than 24 hours before the session are eligible for a refund via Topmate. Late cancellations are non-refundable but may be rescheduled at our discretion.
            </p>
          </Section>

          <Section title="5. Confidentiality">
            <p>
              All information shared during consultations is treated with strict confidentiality and used solely for the advisory service.
            </p>
          </Section>

          <Section title="6. Intellectual Property">
            <p>
              Any written materials provided after a consultation are for personal use only and may not be reproduced or published without written consent.
            </p>
          </Section>

          <Section title="7. Limitation of Liability">
            <p>
              While rigorous methodology is applied, no guidance can guarantee specific outcomes. Acharyaji Ajay L Agarwal shall not be liable for any direct or indirect loss arising from decisions made based on the consultation.
            </p>
          </Section>

          <Section title="8. Acceptable Use">
            <p>By engaging our services, you agree to:</p>
            <ul>
              <li>Provide accurate birth details</li>
              <li>Use guidance for lawful purposes</li>
              <li>Not record sessions without consent</li>
              <li>Maintain courteous communication</li>
            </ul>
          </Section>

        </div>

        <div className="mt-20 pt-10 border-t border-stone-200">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center px-10 py-5 bg-brand-dark text-white hover:bg-brand-gold transition-all duration-300 rounded-sm font-bold tracking-wide text-lg"
          >
            Return to Main Page
          </Link>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-2xl font-serif text-brand-dark mb-5">{title}</h2>
      <div className="space-y-4 text-stone-600 font-medium text-lg leading-relaxed [&_ul]:space-y-3 [&_ul]:pl-5 [&_ul]:list-none [&_ul_li]:flex [&_ul_li]:gap-3 [&_ul_li]:before:content-['·'] [&_ul_li]:before:text-brand-gold [&_ul_li]:before:text-2xl [&_ul_li]:before:leading-none [&_ul_li]:before:flex-shrink-0">
        {children}
      </div>
    </div>
  );
}